import { idtype, resources } from "querypieces";

export default `
...on pageBuilder_resources_BlockType {
	${idtype}
	resources {
		${resources}
	}
}
`